// extracted by mini-css-extract-plugin
module.exports = {"container":"MainPage_container__JVw2g","content":"MainPage_content__3f9aQ"};